import React, { useState, useEffect } from 'react';
import { Modal, Input, Button, Row, Col } from 'antd';
import { useTranslation } from "react-i18next";
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 27px;
    overflow: hidden;
  }
  
  .ant-modal-body {
    padding: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
`;

const IconPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  background-color: #d9d9d9;
  border-radius: 50%;
  margin-right: 15px;
`;

const HeaderText = styled.div`
  h2 {
    margin: 0;
    font-size: 18px;
  }
  p {
    margin: 5px 0 0;
    font-size: 14px;
    color: #666;
  }
`;

const ModalBody = styled.div`
  padding: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const StyledButton = styled(Button)`
  border-radius: 20px;
  margin: 0 10px;
`;

const EditModal = ({ open, onClose, projectInfo, saveProjectInfo }) => {
  const [name, setName] = useState(null);
  const [sector, setSector] = useState(null);
  const [businessDescription, setBusinessDescription] = useState(null);
  const [website, setWebsite] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [instagram, setInstagram] = useState(null);
  const [facebook, setFacebook] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setName(projectInfo?.name);
    setSector(projectInfo?.sector);
    setBusinessDescription(projectInfo?.business_description);
    setWebsite(projectInfo?.socials?.website);
    setLinkedin(projectInfo?.socials?.linkedin);
    setInstagram(projectInfo?.socials?.instagram);
    setFacebook(projectInfo?.socials?.facebook);
  }, [projectInfo, open]);

  return (
    <StyledModal
      open={open}
      onClose={onClose}
      onCancel={onClose}
      footer={null}
      width={800}
      closeIcon={null}
      title={<div style={{ fontSize: "24px" }}><EditOutlined style={{ color: "#5F4DEE", fontSize: "28px", marginRight: "10px" }} />{t("ab_home.edit_modal.title")}</div>}
    >
      <ModalHeader>
        <Row>
          {t("ab_home.edit_modal.text")}
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col span={11}>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder={t("ab_home.project_info_placeholders.name")} />
          </Col>
          <Col span={2} />
          <Col span={11}>
            <Input value={sector} onChange={(e) => setSector(e.target.value)} placeholder={t("ab_home.project_info_placeholders.sector")} />
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col span={24}>
            <Input.TextArea rows={6} value={businessDescription} onChange={(e) => setBusinessDescription(e.target.value)} placeholder={t("ab_home.project_info_placeholders.description")} />
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col span={11}>
            <Input value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="URL Website" />
          </Col>
          <Col span={2} />
          <Col span={11}>
            <Input value={facebook} onChange={(e) => setFacebook(e.target.value)} placeholder="URL Facebook" />
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col span={11}>
            <Input value={instagram} onChange={(e) => setInstagram(e.target.value)} placeholder="URL Instagram" />
          </Col>
          <Col span={2} />
          <Col span={11}>
            <Input value={linkedin} onChange={(e) => setLinkedin(e.target.value)} placeholder="URL Linkedin" />
          </Col>
        </Row>
        <ButtonContainer>
          <StyledButton
            type="primary"
            onClick={() => saveProjectInfo({ name, sector, business_description: businessDescription, socials: { website, facebook, instagram, linkedin } })}
            icon={<SaveOutlined />}
            disabled={!name || !sector || !businessDescription}
          >
            {t("ab_home.edit_modal.save")}
          </StyledButton>
        </ButtonContainer>
      </ModalBody>
    </StyledModal>
  );
};

export { EditModal };